export default __webpack_public_path__ + "static/media/640_dummy2016-raumgestalter01-mobile-de.d85c0e6e.png";